import { useState, useEffect, memo, useCallback } from "react";
import { CSVLink } from "react-csv";
import AnimacionCarga from "../components/animacion_de_carga";
import BarraSuperior from "../components/barra_superior";
import TablaGenerica from "../components/tablas";
import { obtenerNoticias } from "../../functions/consultas";
import Swal from "sweetalert2";
import { subirArchivoFirebase, borrarArchivoFirebaseUrl } from "../../functions/archivos_firebase";
import { crearRegistro, actualizarRegistro, eliminarRegistro } from "../../functions/crud";
import { getDatabase, ref, get, update, set } from "firebase/database";
import BotonSOS from "../components/sos/boton_sos";
import "bootstrap-icons/font/bootstrap-icons.css";


const COLUMNAS = [
  { label: "Fecha",       key: "fecha"      },
  { label: "Título",      key: "titulo"     },
  { label: "Descripción", key: "descripcion"},
  { label: "Recurso",     key: "url_foto1"  },
  { label: "PDF",         key: "url_pdf"    },
];

const IMAGEN_DEFAULT = "https://firebasestorage.googleapis.com/v0/b/coordiph-2.appspot.com/o/RecursosPlantillas%2Fcoordi_logo.png?alt=media&token=20b1ae0c-f038-4830-83ac-198fe0ad8c0f";
const API_URL        = "https://coordiph.herokuapp.com/notificaciones/nuevapush";
const EXT_VIDEO      = [".mp4", ".webm", ".ogg", ".mov", ".avi", ".mkv", ".m4v"];
const PERMISOS_ADMIN = ["RESIDENTE", "CONTADOR", "AUDITOR"];
const LOCALE_CO      = { year: "numeric", month: "long", day: "numeric" };


const urlBase = (url = "") => url.split("?")[0].toLowerCase();

const detectarTipo = (url = "") =>
  EXT_VIDEO.some((e) => urlBase(url).endsWith(e)) ? "video" : "imagen";

const mimeVideo = (url = "") => {
  const u = urlBase(url);
  if (u.endsWith(".webm")) return "video/webm";
  if (u.endsWith(".ogg"))  return "video/ogg";
  if (u.endsWith(".mov"))  return "video/quicktime";
  return "video/mp4";
};

const formatFecha = (fecha) =>
  fecha ? new Date(fecha).toLocaleDateString("es-CO", LOCALE_CO) : "";

const useEsMobil = (breakpoint = 700) => {
  const [es, setEs] = useState(window.innerWidth < breakpoint);
  useEffect(() => {
    const fn = () => setEs(window.innerWidth < breakpoint);
    window.addEventListener("resize", fn);
    return () => window.removeEventListener("resize", fn);
  }, [breakpoint]);
  return es;
};


const actualizarDiccionario = async (codigo, noticia) => {
  const db  = getDatabase();
  const r   = ref(db, `noticias/diccionario/${codigo}`);
  const snap = await get(r);
  if (snap.exists()) {
    const d = snap.val() || {};
    await update(r, { noticia_2: d.noticia_1 ?? null, noticia_1: d.noticia_0 ?? null, noticia_0: noticia });
  } else {
    await set(r, { noticia_0: noticia, noticia_1: null, noticia_2: null });
  }
};

const enviarPush = async ({ titulo, descripcion, urlImagen, esImagen }) => {
  const nit = localStorage.getItem("CodigoCliente");
  const resp = await fetch(API_URL, {
    method:  "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      titulo, comentario: descripcion,
      urlImagen: esImagen ? urlImagen : IMAGEN_DEFAULT,
      fechaPublicacion: new Date().toISOString().substring(0, 10),
      idConjunto: nit, repetirCada: "1", tipoProgramacion: "Ahora",
    }),
  });
  return resp.json();
};


const SWAL_ESTILOS = `
  <style>
    .swal2-input,.swal2-textarea,.swal2-file{
      margin:0!important;width:100%!important;box-sizing:border-box!important;
      padding:10px!important;border:1px solid #d1d5db!important;
      border-radius:5px!important;font-size:14px!important;
    }
    .swal2-textarea{min-height:100px!important;resize:vertical!important;}
  </style>`;

const recursoActualHTML = (noticia) => {
  if (!noticia?.url_foto1) return "";
  const tipo = noticia.tipo || detectarTipo(noticia.url_foto1);
  const media = tipo === "imagen"
    ? `<img src="${noticia.url_foto1}" style="max-width:100%;max-height:200px;border-radius:6px;">`
    : `<video controls preload="metadata" style="max-width:100%;max-height:200px;border-radius:6px;">
         <source src="${noticia.url_foto1}" type="${mimeVideo(noticia.url_foto1)}">
       </video>`;
  return `<div style="margin-bottom:15px;">
    <label style="display:block;margin-bottom:6px;color:#555;font-size:14px;font-weight:500;">Recurso Actual</label>
    <div style="text-align:center;background:#f8f9fa;padding:15px;border-radius:8px;">${media}</div>
  </div>`;
};

const formularioHTML = (noticia = null) => `
  ${SWAL_ESTILOS}
  <div style="text-align:left;padding:20px;">
    <h3 style="margin:0 0 25px;color:#2c3e50;font-size:20px;font-weight:600;">
      ${noticia ? "Editar Noticia" : "Nueva Noticia"}
    </h3>
    <div style="margin-bottom:15px;">
      <label style="display:block;margin-bottom:6px;color:#555;font-size:14px;font-weight:500;">Título</label>
      <input id="titulo" class="swal2-input" placeholder="Título de la noticia" value="${noticia?.titulo || ""}">
    </div>
    <div style="margin-bottom:15px;">
      <label style="display:block;margin-bottom:6px;color:#555;font-size:14px;font-weight:500;">Descripción</label>
      <textarea id="descripcion" class="swal2-textarea" placeholder="Escribe los detalles...">${noticia?.descripcion || ""}</textarea>
    </div>
    <div style="margin-bottom:15px;">
      <label style="display:block;margin-bottom:6px;color:#555;font-size:14px;font-weight:500;">Enlace Externo (opcional)</label>
      <input id="enlace_externo" class="swal2-input" placeholder="https://..." value="${noticia?.enlace_externo || ""}">
    </div>
    <div style="margin-bottom:15px;">
      <label style="display:block;margin-bottom:6px;color:#555;font-size:14px;font-weight:500;">
        Imagen o Video ${noticia ? "(opcional — dejar vacío para mantener actual)" : ""}
      </label>
      <input id="archivo" type="file" accept="image/*,video/*" class="swal2-file">
    </div>
    ${recursoActualHTML(noticia)}
    <div id="preview" style="margin-top:20px;text-align:center;"></div>
    <div style="margin-bottom:15px;margin-top:15px;">
      <label style="display:block;margin-bottom:6px;color:#555;font-size:14px;font-weight:500;">
        Documento PDF (opcional)${noticia?.url_pdf ? " — dejar vacío para mantener el actual" : ""}
      </label>
      <input id="archivo_pdf" type="file" accept="application/pdf" class="swal2-file">
      ${noticia?.url_pdf ? `<a href="${noticia.url_pdf}" target="_blank" rel="noreferrer" style="display:inline-block;margin-top:8px;color:#2563eb;font-size:13px;">📄 Ver documento actual</a>` : ""}
    </div>
  </div>`;

const attachPreview = () => {
  const archivo = document.getElementById("archivo");
  const preview = document.getElementById("preview");
  archivo.addEventListener("change", () => {
    const file = archivo.files[0];
    if (!file) { preview.innerHTML = ""; return; }
    const url     = URL.createObjectURL(file);
    const esVideo = file.type.startsWith("video/");
    const wrap    = `<div style="background:#f8f9fa;padding:15px;border-radius:8px;border:2px dashed #d1d5db;">`;
    preview.innerHTML = wrap + (esVideo
      ? `<video controls preload="metadata" style="max-width:100%;max-height:250px;border-radius:6px;display:block;margin:0 auto;"><source src="${url}" type="${file.type}"></video>`
      : `<img src="${url}" style="max-width:100%;max-height:250px;border-radius:6px;display:block;margin:0 auto;">`)
      + "</div>";
  });
};

const validarFormulario = (esEdicion) => {
  const titulo        = document.getElementById("titulo").value.trim();
  const descripcion   = document.getElementById("descripcion").value.trim();
  const enlaceExterno = document.getElementById("enlace_externo").value.trim();
  const archivo        = document.getElementById("archivo").files[0];
  const archivoPdf     = document.getElementById("archivo_pdf").files[0];
  if (!titulo)                    { Swal.showValidationMessage("El título es obligatorio");              return false; }
  if (!descripcion)               { Swal.showValidationMessage("La descripción es obligatoria");         return false; }
  if (!esEdicion && !archivo)     { Swal.showValidationMessage("Debes seleccionar una imagen o video");  return false; }
  return { titulo, descripcion, enlaceExterno, archivo, archivoPdf };
};

const abrirFormulario = (noticia = null) =>
  Swal.fire({
    title: noticia ? "Editar Noticia" : "Crear Noticia",
    html:  formularioHTML(noticia),
    didOpen: attachPreview,
    showCancelButton:  true,
    confirmButtonText: noticia ? "Guardar" : "Publicar",
    cancelButtonText:  "Cancelar",
    width: 600,
    preConfirm: () => {
      const datos = validarFormulario(!!noticia);
      if (!datos) return false;
      return { ...datos, fecha: new Date().toISOString(), usuario: localStorage.getItem("CorreoElectronico") };
    },
  });


const BotonesAccion = ({ onRefrescar, onCrear, datos }) => (
  <>
    <button onClick={onRefrescar} title="Refrescar"><i className="bi bi-arrow-clockwise" /></button>
    <CSVLink data={datos} headers={COLUMNAS} filename="listado_noticias.csv" separator=";" title="Exportar"
      style={{ padding: "7px 14px", margin: 2, backgroundColor: "#c0392b", color: "#fff", borderRadius: 7, fontSize: "0.82rem", fontWeight: 500, textDecoration: "none" }}>
      <i className="bi bi-download" />
    </CSVLink>
    <button onClick={onCrear} title="Nueva Noticia"><i className="bi bi-plus-lg" /></button>
  </>
);

const BtnNavegacion = ({ onClick, disabled, children }) => (
  <button onClick={onClick} disabled={disabled} style={{
    width: 40, height: 40, borderRadius: "50%", fontSize: 18,
    border: "1px solid #d1d5db",
    background: disabled ? "#f3f4f6" : "#fff",
    color:      disabled ? "#d1d5db" : "#374151",
    cursor:     disabled ? "default"  : "pointer",
    display: "flex", alignItems: "center", justifyContent: "center",
  }}>{children}</button>
);

const BtnAccion = ({ onClick, borde, fondo, color, children }) => (
  <button onClick={onClick} style={{
    padding: "6px 14px", fontSize: 13, borderRadius: 6, cursor: "pointer",
    border: `1px solid ${borde}`, background: fondo, color,
  }}>{children}</button>
);

const RecursoTarjeta = ({ noticia, esMobil }) => {
  if (!noticia.url_foto1) return (
    <div style={{ width: "100%", height: "100%", minHeight: esMobil ? 180 : 240, background: "#f3f4f6", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <span style={{ fontSize: 64 }}>📰</span>
    </div>
  );
  if (noticia.tipo === "video") return (
    <div style={{ width: "100%", height: "100%", minHeight: esMobil ? 0 : 240, display: "flex", alignItems: "center", justifyContent: "center", background: "#f3f4f6" }}>
      <span style={{ fontSize: 72 }}>🎬</span>
    </div>
  );
  return (
    <img src={noticia.url_foto1} alt={noticia.titulo}
      style={{ width: "100%", height: "100%", minHeight: esMobil ? 0 : 240, objectFit: "cover", display: "block" }} />
  );
};

const ModalNoticia = ({ noticia, onCerrar }) => (
  <div onClick={onCerrar} style={{
    position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)",
    display: "flex", alignItems: "center", justifyContent: "center",
    zIndex: 9999, padding: 20,
  }}>
    <div onClick={(e) => e.stopPropagation()} style={{
      background: "#fff", borderRadius: 16, overflow: "hidden",
      width: "100%", maxWidth: 900, boxShadow: "0 8px 40px rgba(0,0,0,0.3)",
      display: "flex", flexDirection: "column",
    }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 20px", borderBottom: "1px solid #e5e7eb" }}>
        <span style={{ color: "#1f2937", fontWeight: 600, fontSize: 16, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {noticia.titulo}
        </span>
        <button onClick={onCerrar} style={{ background: "none", border: "none", color: "#6b7280", fontSize: 24, cursor: "pointer", lineHeight: 1, padding: "0 4px" }}>×</button>
      </div>

      {noticia.tipo === "video" ? (
        <video controls autoPlay playsInline preload="auto"
          style={{ width: "100%", maxHeight: "65vh", display: "block", background: "#f3f4f6" }}>
          <source src={noticia.url_foto1} type={mimeVideo(noticia.url_foto1)} />
        </video>
      ) : (
        <img src={noticia.url_foto1} alt={noticia.titulo}
          style={{ width: "100%", maxHeight: "65vh", objectFit: "contain", display: "block", background: "#f3f4f6" }} />
      )}

      <div style={{ padding: "16px 20px", borderTop: "1px solid #e5e7eb" }}>
        <p style={{ margin: 0, color: "#6b7280", fontSize: 14, lineHeight: 1.6 }}>{noticia.descripcion}</p>
        {noticia.url_pdf && (
          <a href={noticia.url_pdf} target="_blank" rel="noreferrer" style={{ display: "inline-block", marginTop: 10, color: "#2563eb", fontSize: 13, fontWeight: 500, textDecoration: "none" }}>
            📄 Ver documento adjunto
          </a>
        )}
        <span style={{ fontSize: 12, color: "#9ca3af", marginTop: 8, display: "block" }}>{formatFecha(noticia.fecha)}</span>
      </div>
    </div>
  </div>
);

const TarjetaNoticia = ({ noticia, esMobil, esResidente, onVerMedia, onEditar, onEliminar }) => (
  <div style={{
    background: "#fff", border: "1px solid #e5e7eb", borderRadius: 16,
    boxShadow: "0 2px 12px rgba(0,0,0,0.08)", width: "100%", maxWidth: 1500,
    overflow: "hidden", display: "flex", flexDirection: esMobil ? "column" : "row",
  }}>
    <div style={esMobil ? { width: "100%", aspectRatio: "16/9", flexShrink: 0 } : { width: 380, minWidth: 380, flexShrink: 0 }}>
      <RecursoTarjeta noticia={noticia} esMobil={esMobil} />
    </div>

    <div style={{ flex: 1, padding: esMobil ? 16 : "24px 28px", display: "flex", flexDirection: "column", gap: 10 }}>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", justifyContent: esMobil ? "flex-start" : "flex-end" }}>
        {noticia.url_foto1 && (
          <BtnAccion onClick={() => onVerMedia(noticia)} borde="#d1d5db" fondo="#fff" color="#374151">
            {noticia.tipo === "video" ? "▶ Reproducir" : "Vista Previa"}
          </BtnAccion>
        )}
        {noticia.url_pdf && (
          <a href={noticia.url_pdf} target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>
            <BtnAccion borde="#d1d5db" fondo="#fff" color="#374151">📄 Documento Adjunto</BtnAccion>
          </a>
        )}
        {noticia.enlace_externo && (
          <a href={noticia.enlace_externo} target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>
            <BtnAccion borde="#d1d5db" fondo="#fff" color="#374151">🔗 Enlace</BtnAccion>
          </a>
        )}
        {!esResidente && (
          <>
            <BtnAccion onClick={() => onEditar(noticia)} borde="#d1d5db" fondo="#f9fafb" color="#374151">✏ Editar</BtnAccion>
            <BtnAccion onClick={() => onEliminar(noticia)} borde="#fca5a5" fondo="#fef2f2" color="#dc2626">× Eliminar</BtnAccion>
          </>
        )}
      </div>

      <h3 style={{ margin: 0, fontSize: esMobil ? 17 : 20, fontWeight: 700, color: "#1f2937", lineHeight: 1.3 }}>
        {noticia.titulo}
      </h3>
      <p style={{ margin: 0, fontSize: esMobil ? 14 : 15, color: "#6b7280", lineHeight: 1.7, flex: 1 }}>
        {noticia.descripcion}
      </p>
      <div style={{ borderTop: "1px solid #f3f4f6", paddingTop: 10, marginTop: "auto" }}>
        <span style={{ fontSize: 12, color: "#9ca3af" }}>{formatFecha(noticia.fecha)}</span>
      </div>
    </div>
  </div>
);


const ListadoNoticias = memo(() => {
  const [datos,        setDatos]        = useState([]);
  const [cargando,     setCargando]     = useState(true);
  const [indiceActual, setIndiceActual] = useState(0);
  const [modalNoticia, setModalNoticia] = useState(null);

  const esMobil    = useEsMobil();
  const esResidente = PERMISOS_ADMIN.includes(localStorage.getItem("Permisos"));
  const nit         = localStorage.getItem("CodigoCliente");

  const cargar = useCallback(async () => {
    try {
      const data  = await obtenerNoticias();
      const lista = Object.entries(data || {})
        .map(([id, item]) => ({
          id, ...item,
          fecha: item.fecha ? item.fecha.split(" ")[0] : "",
          tipo:  item.tipo || detectarTipo(item.url_foto1 || ""),
        }))
        .sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
      setDatos(lista);
      setIndiceActual(0);
    } catch (e) {
      console.error("Error al obtener noticias:", e);
    } finally {
      setCargando(false);
    }
  }, []);

  useEffect(() => { cargar(); }, [cargar]);

  const guardarNoticia = useCallback(async (noticia = null) => {
    const { value } = await abrirFormulario(noticia);
    if (!value) return;

    try {
      let urlFinal    = noticia?.url_foto1 ?? null;
      let tipoArchivo = noticia?.tipo      ?? null;
      let urlPdf      = noticia?.url_pdf   ?? null;

      if (value.archivo) {
        const urlAnterior   = noticia?.url_foto1 ?? null;
        const nombreArchivo = `${Date.now()}_${value.archivo.name}`;
        urlFinal    = await subirArchivoFirebase(`uploads/${nit}/${nombreArchivo}`, value.archivo);
        tipoArchivo = value.archivo.type.startsWith("image/") ? "imagen" : "video";
        if (urlAnterior) await borrarArchivoFirebaseUrl(urlAnterior);
      }

      if (value.archivoPdf) {
        const urlPdfAnterior = noticia?.url_pdf ?? null;
        const nombrePdf      = `${Date.now()}_${value.archivoPdf.name}`;
        urlPdf = await subirArchivoFirebase(`fichas/${nit}/${nombrePdf}`, value.archivoPdf);
        if (urlPdfAnterior) await borrarArchivoFirebaseUrl(urlPdfAnterior);
      }

      const data = {
        titulo:         value.titulo,
        descripcion:    value.descripcion,
        enlace_externo: value.enlaceExterno || null,
        url_foto1:      urlFinal,
        url_pdf:        urlPdf,
        fecha:          value.fecha,
        usuario:        value.usuario,
        tipo:           tipoArchivo,
      };

      if (noticia) {
        await actualizarRegistro(`coordi_ph/${nit}/noticias/${noticia.id}`, data);
        Swal.fire("Éxito", "Noticia actualizada correctamente", "success");
      } else {
        const id = await crearRegistro(`coordi_ph/${nit}/noticias/`, data);
        await actualizarDiccionario(nit, id);
        await enviarPush({ titulo: data.titulo, descripcion: data.descripcion, urlImagen: data.url_foto1, esImagen: tipoArchivo === "imagen" });
        Swal.fire("Éxito", "Noticia creada correctamente", "success");
      }

      cargar();
    } catch (e) {
      console.error(e);
      Swal.fire("Error", "No se pudo guardar la noticia", "error");
    }
  }, [nit, cargar]);

  const eliminarNoticia = useCallback(async (noticia) => {
    const { isConfirmed } = await Swal.fire({
      title: "¿Eliminar Noticia?",
      html: `<div style="text-align:left;padding:15px;">
        <div style="background:#f8f9fa;padding:15px;border-radius:8px;border-left:4px solid #e74c3c;">
          <strong style="display:block;margin-bottom:8px;color:#2c3e50;">${noticia.titulo}</strong>
          <p style="color:#7f8c8d;margin:0;font-size:14px;">${noticia.descripcion}</p>
        </div>
        <p style="margin-top:15px;color:#e74c3c;">Esta acción no se puede deshacer</p>
      </div>`,
      icon: "warning", showCancelButton: true,
      confirmButtonColor: "#d33", confirmButtonText: "Eliminar", cancelButtonText: "Cancelar",
    });

    if (!isConfirmed) return;
    try {
      await eliminarRegistro(`coordi_ph/${nit}/noticias/${noticia.id}`);
      if (noticia.url_foto1) await borrarArchivoFirebaseUrl(noticia.url_foto1);
      if (noticia.url_pdf)   await borrarArchivoFirebaseUrl(noticia.url_pdf);
      Swal.fire({ title: "Eliminada", text: "Noticia eliminada correctamente", icon: "success", timer: 2000, showConfirmButton: false });
      cargar();
    } catch (e) {
      console.error(e);
      Swal.fire("Error", "No se pudo eliminar la noticia", "error");
    }
  }, [nit, cargar]);

  if (cargando) return <AnimacionCarga />;

  if (!esResidente) return (
    <>
      <BarraSuperior />
      <TablaGenerica
        datos={datos} mostrarBarraSuperior={false}
        titulos={COLUMNAS.map(c => c.label.toUpperCase())}
        campos={COLUMNAS.map(c => c.key)}
        columnaOrdenInicial={0} direccionOrdenInicial="desc"
        botones={[{ texto: "Editar", icono: "bi-pencil", accion: (n) => guardarNoticia(n) }, { texto: "Eliminar", icono: "bi-trash", accion: eliminarNoticia }]}
        contenidoExtra={<BotonesAccion onRefrescar={cargar} onCrear={() => guardarNoticia()} datos={datos} />}
      />
      <BotonSOS />
    </>
  );

  const noticia = datos[indiceActual];

  return (
    <>
      <BarraSuperior />

      {modalNoticia && <ModalNoticia noticia={modalNoticia} onCerrar={() => setModalNoticia(null)} />}

      <div style={{ padding: "20px 16px 100px", display: "flex", flexDirection: "column", alignItems: "center", gap: 16 }}>
        {datos.length === 0 && (
          <div style={{ position: "fixed", inset: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <p style={{ color: "#888", fontSize: 15 }}>No hay noticias disponibles.</p>
          </div>
        )}

        {noticia && (
          <TarjetaNoticia
            noticia={noticia}
            esMobil={esMobil}
            esResidente={esResidente}
            onVerMedia={setModalNoticia}
            onEditar={(n) => guardarNoticia(n)}
            onEliminar={eliminarNoticia}
          />
        )}
      </div>

      {datos.length > 1 && (
        <div style={{
          position: "fixed", bottom: 20, left: "50%", transform: "translateX(-50%)",
          display: "flex", alignItems: "center", gap: 16,
          background: "rgba(255,255,255,0.95)", backdropFilter: "blur(6px)",
          border: "1px solid #e5e7eb", borderRadius: 50,
          padding: "10px 20px", boxShadow: "0 4px 16px rgba(0,0,0,0.12)", zIndex: 900,
        }}>
          <BtnNavegacion onClick={() => setIndiceActual(i => Math.max(0, i - 1))} disabled={indiceActual === 0}>‹</BtnNavegacion>
          <span style={{ fontSize: 13, color: "#9ca3af", minWidth: 60, textAlign: "center" }}>
            {indiceActual + 1} de {datos.length}
          </span>
          <BtnNavegacion onClick={() => setIndiceActual(i => Math.min(datos.length - 1, i + 1))} disabled={indiceActual === datos.length - 1}>›</BtnNavegacion>
        </div>
      )}

      <BotonSOS />
    </>
  );
});

export default ListadoNoticias;
